import { Helmet } from 'react-helmet-async';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>
          Nduro Kimotho & Co Advocates | Leading Law Firm in Nairobi, Kenya
        </title>
        <meta
          name="description"
          content="Nduro Kimotho & Co Advocates provides expert legal services in corporate law, conveyancing, litigation, real estate, and more. Advocates of the High Court of Kenya based in Nairobi."
        />
        <meta
          name="keywords"
          content="advocate Kenya, corporate lawyer Nairobi, conveyancing lawyer Kenya, Milton Nduro Kimotho, law firm Nairobi"
        />

        {/* Open Graph / Social sharing */}
        <meta
          property="og:title"
          content="Nduro Kimotho & Co Advocates – Trusted Legal Expertise"
        />
        <meta property="og:description" content="..." />
        <meta
          property="og:image"
          content="https://www.ndurokimotho.co.ke/og-image.jpg"
        />
        <meta property="og:url" content="https://www.ndurokimotho.co.ke/" />

        {/* Twitter / X */}
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {/* page content */}
    </>
  );
}
